/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.0.0
 */

export const gutter = 8; // px

// TODO Waiting responsitive
export const minSiteWidth = '1280px';
export const maxSiteWidth = '1280px';

export const fontSizeBase = '15px';
export const fontSizeSmall = '12px';
